import { useCallback, useEffect, useState } from "react";
import { axios, errorResponse } from "../../helpers";

const useLatestTransactions = (token, limit = 10) => {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const formatTransactions = useCallback((items) => {
    return items.map((transaction) => {
      const fabricName = transaction.order_details?.[0]?.fabric?.fabric_name;
      const productName =
        fabricName ||
        (transaction.product_names?.length
          ? transaction.product_names.join(", ")
          : "N/A");

      return {
        id: transaction.transaction_id,
        customerName: transaction.customer_name || "N/A",
        customerEmail: transaction.customer_email || "N/A",
        productName: productName,
        date: new Date(transaction.transaction_date).toLocaleDateString(
          "id-ID"
        ),
        orderStatus: transaction.order_status,
        paymentStatus: transaction.payment_status,
        totalAmount: new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        }).format(transaction.total_amount || 0),
        rawTotalAmount: transaction.total_amount || 0,
        totalItems: transaction.total_items || 0,
        orderType: transaction.order_type,
      };
    });
  }, []);

  const fetchLatestTransactions = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(
        `/v1/dashboard/latest-transactions?limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setTransactions(formatTransactions(response.data.data));
        setError("");
      } else {
        setError(
          response.data.message || "Failed to fetch latest transactions"
        );
      }
    } catch (err) {
      const msg = errorResponse(err) || "Error fetching latest transactions";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  }, [token, limit, formatTransactions]);

  useEffect(() => {
    fetchLatestTransactions();
  }, [fetchLatestTransactions]);

  return { transactions, isLoading, error, refetch: fetchLatestTransactions };
};

export default useLatestTransactions;
